import { Component, OnInit } from '@angular/core';
import { UtilityServiceService } from 'app/services/utility-service.service';

@Component({
  selector: 'acc-manager',
  templateUrl: './manager.component.html',
  styleUrls: ['./manager.component.css']
})
export class ManagerComponent implements OnInit {

  ctrlData: any = { carrierId: 0, isApproval:true,permitId: 0, currentActive: 1, action: 0, ctrlAction: 0, data: {} };


  constructor(public utility: UtilityServiceService) { }

  ngOnInit() {
    this.utility.currentActive = 1;
  }

  changeView = (activeC: number, action = 0) => {
    this.utility.currentActive = activeC;
    this.ctrlData.action = action;

  }

}
